import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Axios from "axios";
import { SnackbarProvider, useSnackbar } from 'notistack';
import Navbar from "../../../components/Navbar";
import Brackground from "../../../components/Background";
import Container from "../../../components/Container";
import Header from "../../../components/Header";
import style from "./AgendamentoPesagem.module.css";
import SubmitButton from "../../../components/Button";
import modal from "./Modal.module.css";
import VintePes from "./20.png";
import QuarentaPes from "./40.png";
import modalStyle from "./Modal.module.css"; // Importando o estilo modular
import jsPDF from "jspdf";
import "react-calendar/dist/Calendar.css"; // Importa os estilos padrão do calendário
import Dialog from '@mui/material/Dialog';

const AgendamentoPesagem = () => {
  const navigate = useNavigate();

  useEffect(() => {
    getTransp()
  }, [])

  const [pedidoMic, setPedidoMic] = useState([]);
  const [destino, setDestino] = useState('');
  const [doc, setDoc] = useState('');
  const [placacavalo, setPlacacavalo] = useState('');
  const [placa1, setPlaca1] = useState('');
  const [placa2, setPlaca2] = useState(null);
  const [placa3, setPlaca3] = useState(null);
  const [data, setData] = useState('');
  const [transportadora, setTransportadora] = useState([])
  const [tipopesagem, setTipopesagem] = useState('M'); // Defina 'C' como valor inicial
  const [tipoveiculo, setTipoveiculo] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [checked, setChecked] = useState(false);
  const usuario = JSON.parse(localStorage.getItem("user_token")).id;
  const cnpjUsuario = usuario.split('.')[1]; // Certifique-se de que isso extrai apenas o CNPJ corretamente


  const [tipofluxo, setTipoFluxo] = useState("ENTRADA");
  const [hasDamage, setHasDamage] = useState(false);
  const [photos, setPhotos] = useState([]);
  const [numeroContainer, setNumeroContainer] = useState("");
  const [cpfMotorista, setCpfMotorista] = useState("");
  const [nomeMotorista, setNomeMotorista] = useState("");
  const [transportadoras, setTransportadoras] = useState([]); // Estado para lista de transportadoras
  const [selectedTransportadora, setSelectedTransportadora] = useState(""); // Inicializa com string vazia
  const [observacao, setObservacao] = useState("");
  const [codMotorista, setCodMotorista] = useState(null); // Armazena o COD_MOTORISTA
  const [showModal, setShowModal] = useState(false); // Controle do modal
  const [nomeMotoristaModal, setNomeMotoristaModal] = useState(""); // Nome inserido no modal
  const [tipoContainer, setTipoContainer] = useState("");
  const [showAll, setShowAll] = useState(false);
  const [activeTab, setActiveTab] = useState("1"); // Começa na primeira aba
  const [date, setDate] = useState(new Date()); // Estado para a data selecionada
  const [horario, setHorario] = useState(""); // Estado para o horário selecionado
  const [activePage, setActivePage] = useState(0); // Página atual para seleção de horários
  const [openA, setOpenA] = useState(false);

  const LOGO_BASE64 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKcAAAA8CAYAAAADt6psAAAKN2lDQ1BzUkdCIElFQzYxOTY2LTIuMQAAeJydlndUU9kWh8+9N71QkhCKlNBraFICSA29SJEuKjEJEErAkAAiNkRUcERRkaYIMijggKNDkbEiioUBUbHrBBlE1HFwFBuWSWStGd+8ee/Nm98f935rn73P3Wfvfda6AJD8gwXCTFgJgAyhWBTh58WIjYtnYAcBDPAAA2wA4HCzs0IW+EYCmQJ82IxsmRP4F726DiD5+yrTP4zBAP+flLlZIjEAUJiM5/L42VwZF8k4PVecJbdPyZi2NE3OMErOIlmCMlaTc/IsW3z2mWUPOfMyhDwZy3PO4mXw5Nwn4405Er6MkWAZF+cI+LkyviZjg3RJhkDGb+SxGXxONgAoktwu5nNTZGwtY5IoMoIt43kA4EjJX/DSL1jMzxPLD8XOzFouEiSniBkmXFOGjZMTi+HPz03ni8XMMA43jSPiMdiZGVkc4XIAZs/8WRR5bRmyIjvYODk4MG0tbb4o1H9d/JuS93aWXoR/7hlEH/jD9ld+mQ0AsKZltdn6h21pFQBd6wFQu/2HzWAvAIqyvnUOfXEeunxeUsTiLGcrq9zcXEsBn2spL+jv+p8Of0NffM9Svt3v5WF485M4knQxQ143bmZ6pkTEyM7icPkM5p+H+B8H/nUeFhH8JL6IL5RFRMumTCBMlrVbyBOIBZlChkD4n5r4D8P+pNm5lona+BHQllgCpSEaQH4eACgqESAJe2Qr0O99C8ZHA/nNi9GZmJ37z4L+fVe4TP7IFiR/jmNHRDK4ElHO7Jr8WgI0IABFQAPqQBvoAxPABLbAEbgAD+ADAkEoiARxYDHgghSQAUQgFxSAtaAYlIKtYCeoBnWgETSDNnAYdIFj4DQ4By6By2AE3AFSMA6egCnwCsxAEISFyBAVUod0IEPIHLKFWJAb5AMFQxFQHJQIJUNCSAIVQOugUqgcqobqoWboW+godBq6AA1Dt6BRaBL6FXoHIzAJpsFasBFsBbNgTzgIjoQXwcnwMjgfLoK3wJVwA3wQ7oRPw5fgEVgKP4GnEYAQETqiizARFsJGQpF4JAkRIauQEqQCaUDakB6kH7mKSJGnyFsUBkVFMVBMlAvKHxWF4qKWoVahNqOqUQdQnag+1FXUKGoK9RFNRmuizdHO6AB0LDoZnYsuRlegm9Ad6LPoEfQ4+hUGg6FjjDGOGH9MHCYVswKzGbMb0445hRnGjGGmsVisOtYc64oNxXKwYmwxtgp7EHsSewU7jn2DI+J0cLY4X1w8TogrxFXgWnAncFdwE7gZvBLeEO+MD8Xz8MvxZfhGfA9+CD+OnyEoE4wJroRIQiphLaGS0EY4S7hLeEEkEvWITsRwooC4hlhJPEQ8TxwlviVRSGYkNimBJCFtIe0nnSLdIr0gk8lGZA9yPFlM3kJuJp8h3ye/UaAqWCoEKPAUVivUKHQqXFF4pohXNFT0VFysmK9YoXhEcUjxqRJeyUiJrcRRWqVUo3RU6YbStDJV2UY5VDlDebNyi/IF5UcULMWI4kPhUYoo+yhnKGNUhKpPZVO51HXURupZ6jgNQzOmBdBSaaW0b2iDtCkVioqdSrRKnkqNynEVKR2hG9ED6On0Mvph+nX6O1UtVU9Vvuom1TbVK6qv1eaoeajx1UrU2tVG1N6pM9R91NPUt6l3qd/TQGmYaYRr5Grs0Tir8XQObY7LHO6ckjmH59zWhDXNNCM0V2ju0xzQnNbS1vLTytKq0jqj9VSbru2hnaq9Q/uE9qQOVcdNR6CzQ+ekzmOGCsOTkc6oZPQxpnQ1df11Jbr1uoO6M3rGelF6hXrtevf0Cfos/ST9Hfq9+lMGOgYhBgUGrQa3DfGGLMMUw12G/YavjYyNYow2GHUZPTJWMw4wzjduNb5rQjZxN1lm0mByzRRjyjJNM91tetkMNrM3SzGrMRsyh80dzAXmu82HLdAWThZCiwaLG0wS05OZw2xljlrSLYMtCy27LJ9ZGVjFW22z6rf6aG1vnW7daH3HhmITaFNo02Pzq62ZLde2xvbaXPJc37mr53bPfW5nbse322N3055qH2K/wb7X/oODo4PIoc1h0tHAMdGx1vEGi8YKY21mnXdCO3k5rXY65vTW2cFZ7HzY+RcXpkuaS4vLo3nG8/jzGueNueq5clzrXaVuDLdEt71uUnddd457g/sDD30PnkeTx4SnqWeq50HPZ17WXiKvDq/XbGf2SvYpb8Tbz7vEe9CH4hPlU+1z31fPN9m31XfKz95vhd8pf7R/kP82/xsBWgHcgOaAqUDHwJWBfUGkoAVB1UEPgs2CRcE9IXBIYMj2kLvzDecL53eFgtCA0O2h98KMw5aFfR+OCQ8Lrwl/GGETURDRv4C6YMmClgWvIr0iyyLvRJlESaJ6oxWjE6Kbo1/HeMeUx0hjrWJXxl6K04gTxHXHY+Oj45vipxf6LNy5cDzBPqE44foi40V5iy4s1licvvj4EsUlnCVHEtGJMYktie85oZwGzvTSgKW1S6e4bO4u7hOeB28Hb5Lvyi/nTyS5JpUnPUp2Td6ePJninlKR8lTAFlQLnqf6p9alvk4LTduf9ik9Jr09A5eRmHFUSBGmCfsytTPzMoezzLOKs6TLnJftXDYlChI1ZUPZi7K7xTTZz9SAxESyXjKa45ZTk/MmNzr3SJ5ynjBvYLnZ8k3LJ/J9879egVrBXdFboFuwtmB0pefK+lXQqqWrelfrry5aPb7Gb82BtYS1aWt/KLQuLC98uS5mXU+RVtGaorH1futbixWKRcU3NrhsqNuI2ijYOLhp7qaqTR9LeCUXS61LK0rfb+ZuvviVzVeVX33akrRlsMyhbM9WzFbh1uvb3LcdKFcuzy8f2x6yvXMHY0fJjpc7l+y8UGFXUbeLsEuyS1oZXNldZVC1tep9dUr1SI1XTXutZu2m2te7ebuv7PHY01anVVda926vYO/Ner/6zgajhop9mH05+x42Rjf2f836urlJo6m06cN+4X7pgYgDfc2Ozc0tmi1lrXCrpHXyYMLBy994f9Pdxmyrb6e3lx4ChySHHn+b+O31w0GHe4+wjrR9Z/hdbQe1o6QT6lzeOdWV0iXtjusePhp4tLfHpafje8vv9x/TPVZzXOV42QnCiaITn07mn5w+lXXq6enk02O9S3rvnIk9c60vvG/wbNDZ8+d8z53p9+w/ed71/LELzheOXmRd7LrkcKlzwH6g4wf7HzoGHQY7hxyHui87Xe4Znjd84or7ldNXva+euxZw7dLI/JHh61HXb95IuCG9ybv56Fb6ree3c27P3FlzF3235J7SvYr7mvcbfjT9sV3qID0+6j068GDBgztj3LEnP2X/9H686CH5YcWEzkTzI9tHxyZ9Jy8/Xvh4/EnWk5mnxT8r/1z7zOTZd794/DIwFTs1/lz0/NOvm1+ov9j/0u5l73TY9P1XGa9mXpe8UX9z4C3rbf+7mHcTM7nvse8rP5h+6PkY9PHup4xPn34D94Tz+49wZioAAAAJcEhZcwAALiMAAC4jAXilP3YAAA4OSURBVHic7V0NdBTVFX7vzWyymx8gbhKgQqVQj/hD/avgqQrUqsef0tojLdqjLYLCSXaJASFY63FP1JbDj5hsEgKtthZ/qVal1Vp/qhX/jtWqRaCoFauCoCQgkJDNJvte790ZYIElc3f3kZ3k7HfOZGZ37955O/O9++59786NqZRiObgLG4TIG8lYHRzizZEcNua84Z084uf7PhMEGbsZyd4/6LXRs46kx8n2eYfI4eaTcrOp/crmkDFGMTYRdhWpfo+n+ZmTDOW7yWRT+V7id3B7GzpojpwuBFiOy9O5sf0JXuBojpwugxCCdzD2g2y3I9vIy5HTfWhn7NuwOzbb7cg2wHKKHDldBghYLs92G9wAI2c5XYkfZrsBboDIkdNd6BTim7A7OdvtcAPM3LDuLuSi9APgOcvpLvDckL4fuWHdRWgXohxuxney3Q63QOSGdfcAbsQkFr8nOdjIWU4XITeFlICc5XQJvhCicBBj30vjq4mJGkcb6ZwL47v8NM+Xs5xuwGAp22FXkO126AT40KcAue6Bw7HpfD8XreegHZjuN4qxm4FYv2DxJfL0wPvKsL4sHB6vDOMc8EO+rhgbgO9xpWKK8w6mVBu8/HztunXh5cuXd6V7jjvvvLPQ6/UOF1IOlUIMZJYlwyHJIzBeUWp/sCI5QEoP49zAz2Ez4R2hlMJhDOVw+IvBezF4D63ibvhgd4yxzfDepy0tLdtCoVBvDce9hg4hzhplWcsxGtS533I2NjZeYBjGs9xOD9w/Sc25/Yb1zpgxYx6C3edUvbW1taKspORSZhiTgejnFXi9IxgSS4jkITM/MD0e/1wcLsX54VPoie8Z9r68tLStuanpX0DcJ6Ld3Suqq6s7qO12IzYL4Stj7Da4IrPZgZ+ZCVbCjdzhenLCL/01c85bXR8IBMjEbGhoOAUIch8cnhZ/IwmpjjKKYJsAxJ2Q7/FcBscX9nYDdCEixPhSxu6Gw+M1qNsCo8vMAimfwnVcV5MTh3NuGGc5ySkpf0fVCZb4VFOIl+BwYEaN04cLFi1aNLCmpmZXthuSCnYIMQD8noXQrWey9JLeE4GPmNwTYWzuICn3XwdXk5MLUU0Q6+qIRu+n6Fu8eHFxUUHBE8w9xIyjoKAg7cAhG9grxCWFjC2Hw69rUPcJbNd7pXzOe8gHriUnWLhhBueTCKJ/ufHGG7+k6ARihmA3IqOG6UfXunXrvsp2IyjYI4QfelEduFpXa1CH1nIFRIs1fin3JBNwLTnBub6eEdqnYrHfU/TV19cPzTPNSuLpYYRh78Dl2wT7VvBJ90LwEoVjnCHoEnhhregdN+hDHCN73NCXHMasDvANRgsONmYyy9BbgEh8MhCzEQ4HZ6oLSLkJ/IDrwFq+eKi1TIQryQmRtAkBy3UE0c+379z5N4pOIGYAdj4nObhwf97T1jZ1/vz5Oyl6j4RlTU2vwA04x/F8Sq3J5DxHGzCED4Ue1gS98Eca1OH0WSM4lTfbCw89wpXkLPf7L4Hd1wiiK0OhULeTEJA9D8h+vZMcEHOPDmIigJilJEEpV2d6rqOFTiGmAjGXwmFJprrg2n4Iu+lgLV+mml5XkhMwnSADA22UNKSXHXMMTteUO8lxpR7RQUzwl0+Hsf4ER0FwG1569dUXKquqMj2lVgApR6A/CB3sIg3qYrDd1cLYrcOkTGk+13XkbF6yZAjz+S5zkoOL90rl7NkfUHRC1P8z0smBnCQ5p/NxPpIg9pnkPLhq1aqYjnPqQK0Q4ibG0C9fwC3/OVNshPs0Dazl68PS+LLryAnERCI5tgusHGluc+nSpaW+/PxLCaKt/16//u8UnU6YNWvWYw0NDSNFLHYs3JxByjDyuZS46tkOTPwqFot9dsMNN2zVcS5daBNi9E3WZLqjn0wAulpLtgHfj5Mykq4S95FTqalOKzboG/LW1kcp6vLz869itASER3RFzcBDrHH0sb25Gi8JYY5jbK6HMZxm6yl4puI9iHqm+aR867gMFbmKnMvC4XHcME50kgPq/rEiFGqj6BRKXUNanozFyKtM/QUQiZ96tpWocaYGddixF3zE2K9OkjKqQZ+7yAnEnEoSJC5XNjU1jRacOy5/At6tqKp6k3TufoD/CpE/nLFbIBKfz6ysqkzxLrgr1xZI+e5JGpTtg2vIWVtb6y0vLZ1CEN1YMWvWaxSdVKuplPoNRV9/QIcQZw+3fEsdz8d3gv9yxwbGFp4hpfaFBNeQs9zvx8diHefTFDEQwoJYTQ0NPyWItoOP9ABFZ1+G/SjIHYIxnLfS8SDdWxD1TCuU8r0zNChLBteQE0CZ7unmkch9FGXhcHg8o62jPxwMBndTdPZVdApx/kDGcHQYpUFdBKxl7RsQjU+Q0nEBJBO4gpz2urfjhC9clL9Wzp27jaJTEJMTVCz2W4pcX8RXQgyE8HsJODbTeeZpbYjXYeyeViTlxgkalDnBFeT0GAYOv85tIQZCdXV1vnyP58eOgkqtrayqeoOis68BfMtJPsaamZ5yih1gGG59krG7JkvZa4sGriAn5/wagti27Tt2PEXR5/F4rmCEnE3J+d0UfX0JbUKUQfhdByMHxd+m4OUoWN5iKT+crEkhFVknZ3N9/WnMNE91koNA6D5KkgcCbgwloynS1dXVrwKhiBBXAjHDcFimQR0GijcvYqwxJGVWHsbLOjmBmKR1b8U5aUhvaGg43hRiPEH08erq6h0UnW4HDOHHQods5lZJm4wBQ/iLmG/pk3JTSIfCNJFVck6ZMsWYMH78lQRP/bVAILCRohOIOY0RnH8wBX+g6HMz7Prx04GYi+HlIA0qMSO9poCxFfYSbFaRVXJOOPfcicCioU5ySkpSahwmKZeVlv6cQPbNa9aseR4IT1HrSnQKMXIvYzjTcL4OfcDEZ2A3wyvlp255oD6r5ORCXEUQa2+PRFZR9GHeJonsSj3kplS1VIBpbTWMVYG1vAN+a6EGlfi041ywlve4wVomImvktJcrr3CSg6u1et68eUkfgDoUEPVfS5EDy/AQRc5tgEj8RDutTVcdz6fgWswE33KLW6xlIvaTEwMJA24u3OARYFpK4E7jUuJAOC6OC3COGeLPVAQCc3WcuLS0FGcmnP2kWIxEpHA4PNhjGJS8zfeDweA7FJ09Af29xnC4Bq7LRWDByqETifi/AVTKgOCtkFsPvCl4/cuKYDCjif63hfCcxNh8iMRvYelXbUvETmhvNQzhKzXoOmqIk7O+vn5Qnmm+Dof++LuJyRIHjnEyFzNYtJDTfrrSCa1rN2x4hqIPAiFcEaJk2DxO0eeEpoYGzOhZsO/1YWVyDgDT0dIm514hTj+ZMZypOC1dHYfgCfBnKgukdFWyczLEyekRApMu/I7SSpGI4gSw0mcCmc4jnO8BagIwdUhXsdjTFLmegHWWwCUhdVKV5jX7RAjvEMZChmUMdLhfLWAtZ4G1fFiDrl6B9aOFuJgkzfn7mZ7QttIYfTtP9xBXcOyJfEoKmIxKmXHeZllJCRZ6pXTmLWvXr38yVf0RIc4ZYvmWo9NoXjI82s1YoFBKUvEJt8C0U8smEuWrmpuaBigpNwFxtkJ0twu2NtM0MfO5MxqNHhTtwfsGWA4f7DH9v4hLOQ6IiZZghNOJQNGrgUDgPdqvMKklq3mex1PX3Nj4XLdSG6G9Xxa0te2FO4btN/1+vyna2jyyqMhndHd7uw3DiwUTcBOW730cdNBvccOgzDLgb1iSyqMf24UoKrYeLsOHzHSktX0BgU4AAp4/6XBUexsmDLH4COsQojzKLuBCxEtZGIaBf/Z/6Mt3uARJygYeCXBjbycLM/Zdohx60DPg7wwTjkwv9BnYDnpmuLjYKtPh8Rw8lqZaiU6pTdJKvCChU4gLB1hpbSNSO9ER8SD0uKpiKVs16et14PV3338MU2p1IBhMxVdzXJvPAuYFg8FOJ6HdQpTkWWlt6DPrSGvbCp2iAqzl6r5oLRNhcqW8WahP2RM+7ohGKYkbidDx1KA2gNV/sDIYfMxJrkOIy4FAyxhh4YCIe6E3zBkgZcaFIdwAE3rZO0b8emrptZniA2jPxXPmzGlJ8XtYb1NHdQoduD/a1TWjJ4F2IQbDkBUGJ+cnms75mV109em+bi0TYcLQswGCHEw+wU1HyeRUgR1jHQRZ90ZjseZ0SlB3dnVNy/d4MP2tNxK0kwEXWF6IKbUQrufzPQlCJH41ELOOUaJ9ZyQtutpfEPf5KwKB25ctXbqS5eXhlNJoGOYxRvDDkF/IrPJ+RfaGxziEYgdNxdJixIoXrwUu51bQiQVDMWDAaPyfqZTMTgYg9BbYTQyHwyd4ILAA/SfCTRvFkQBKHWP/hn3tNuzfnWo0jLmkkfimFD5z9DHo/Q8cv8kikWcrHB4fAVIOZ1b9oUtS/oHJ8T9mFV193lU+jUbsD0gr58xBwqygfAlT3caOHes1TdPT3d2d5/V6Td7Z6ek2TSWEwLIrUnR0yE7TjO7atWtvKBRKuyRJKqiqqsJ5WNJcLE6ks+QExfdM6J0i5vcLo7UVJwcj1ETnw5RZaW0zgZQLmf2fQDIEWsvmPYzNL5OSVFiiryKtlQc7o8exvqKbYf+rlSPlO2ipWLFHiOM7rKVLLe4GkPIju+jqP/qrtUxE9jPh+yEeFcL4PmOz8xi7jREK1hKAnSgMftEtlKKr/QU5cmoG/lu9SdbS4zhNKj9QVtHVVzKud93HkCOnJuj6t3oJiBdd3Z5G0dX+ghw5NcAOevBR3BJlWU28ria398wKsgQ78NpUh8skyu6GcbzGJ+Ub6RRd7S/4P+IKbZ5IXRm8AAAAAElFTkSuQmCC";

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const FecharDetalhesOp = () => {
    setOpenA(false); // Atualiza o estado para fechar o Dialog
  };


  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleCheckboxChange = (event) => {
    setChecked(event.target.checked);
  };

  const handleLinkClick = (e) => {
    e.preventDefault(); // Impede o comportamento padrão do link
    handleOpenModal(); // Sempre abre o modal independentemente do estado do checkbox
  };

  const validaPlaca = (placa) => {
    // Expressão regular para validar placas no formato antigo (AAA1234) ou Mercosul (AAA1B23)
    const placaRegex = /^[A-Z]{3}\d{4}$|^[A-Z]{3}\d{1}[A-Z]{1}\d{2}$|^[A-Z]{3}\d{2}[A-Z]{1}\d{1}$/;

    return placaRegex.test(placa);
  };

  const formatarCPF = (cpf) => {
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }

  const validaDados = async () => {
    if (!checked) {
      showAlert('Por favor, aceite os termos antes de prosseguir com o agendamento.', 'warning');
      return;
    }

    if (
      !doc ||
      !tipoveiculo || // Verifique se o campo "Modelo do AUTO" foi preenchido
      !placacavalo ||
      !transportadora ||
      !tipopesagem
    ) {
      showAlert('Preencha todos os campos.', 'error'); // Mostra um alerta de erro
      return;
    }

    if (!validaPlaca(placacavalo)) {
      showAlert('Placa do cavalo deve estar no formato correto (Ex: AAA1234 ou AAA1B23)', 'error');
      return;
    }

    if (placa1 && !validaPlaca(placa1)) {
      showAlert('Placa da carreta 1 deve estar no formato correto (Ex: AAA1234 ou AAA1B23)', 'error');
      return;
    }

    if (placa2 && !validaPlaca(placa2)) {
      showAlert('Placa da carreta 2 deve estar no formato correto (Ex: AAA1234 ou AAA1B23)', 'error');
      return;
    }

    if (placa3 && !validaPlaca(placa3)) {
      showAlert('Placa da carreta 3 deve estar no formato correto (Ex: AAA1234 ou AAA1B23)', 'error');
      return;
    }

    else {

    }

  };

  const validaTecla = (e) => {
    if (e.key === 'Enter') {
      validaDados()
    }
  }

  const getDate = () => {
    const date = new Date();
    date.setHours(date.getHours() - 3); // Adjust for timezone if needed
    return date.toISOString().slice(0, 19).replace('T', ' ');
  }

  const { enqueueSnackbar } = useSnackbar();
  const showAlert = (txt, variant) => {
    enqueueSnackbar(txt, { variant: variant });
  }

  let { nome } = useParams();
  let { cpf } = useParams();
  let { cnh } = useParams();
  let { id } = useParams();

  const formatCPF = (cpf) => {
    // Remove quaisquer caracteres não numéricos
    const onlyNumbers = cpf.replace(/\D/g, "");

    // Formata a string como ###.###.###-##
    return onlyNumbers.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  };

  const formatDateTime = (isoString) => {
    const date = new Date(isoString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Mês começa em 0
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${day}/${month}/${year} - ${hours}:${minutes}`;
  };

  // Função para buscar motorista
  const getMotorista = () => {
    const cpfSemMascara = cpfMotorista.replace(/\D/g, "");

    if (!cpfSemMascara || cpfSemMascara.length < 11) {
      showAlert("CPF inválido ou não informado corretamente.", "error");
      setNomeMotorista("");
      setCodMotorista(null);
      return;
    }

    Axios.get(`https://portal.jc7transportes.com.br/api/motorista/busca/${cpfSemMascara}`)
      .then((res) => {
        if (res.data && res.data.length > 0) {
          setNomeMotorista(res.data[0].NOME_MOTORISTA);
          setCodMotorista(res.data[0].COD_MOTORISTA);
        } else {
          setNomeMotorista("");
          setCodMotorista(null);
          setShowModal(true); // Exibe o modal caso o motorista não seja encontrado
        }
      })
      .catch((error) => {
        console.error("Erro ao buscar motorista:", error);
        alert("Erro ao buscar motorista.");
      });
  };

  // Busca transportadoras da API
  const getTransp = () => {
    Axios.get(`https://portal.jc7transportes.com.br/api/transportadora`)
      .then((res) => {
        setTransportadoras(res.data);
      })
      .catch((error) => {
        console.error("Erro ao buscar transportadoras:", error);
      });
  };

  // Função para adicionar um novo motorista
  const addMotorista = () => {
    if (!nomeMotoristaModal || nomeMotoristaModal.trim() === "") {
      alert("Por favor, insira o nome do motorista.");
      return;
    }

    const cpfSemMascara = cpfMotorista.replace(/\D/g, "");

    const payload = {
      nome: nomeMotoristaModal,
      cnh: 0,
      cpf: cpfSemMascara,
      usuario: "USUARIO_DO_MOTORISTA", // Adapte conforme necessário
    };

    Axios.post("https://portal.jc7transportes.com.br/api/motorista/criar", payload)
      .then((response) => {
        if (response.data === "sucesso") {
          alert("Motorista cadastrado com sucesso!");
          setShowModal(false); // Fecha o modal após sucesso
          getMotorista(); // Atualiza a busca após a inserção
        } else {
          alert("Erro ao cadastrar motorista.");
        }
      })
      .catch((error) => {
        console.error("Erro ao adicionar motorista:", error);
        alert("Erro ao adicionar motorista.");
      });
  };


  useEffect(() => {
    const fetchTransportadoras = async () => {
      try {
        // Obter o usuário logado
        const usuario = JSON.parse(localStorage.getItem("user_token")).id; // Exemplo: "26093215000198"

        // Buscar a lista de transportadoras
        const response = await Axios.get(`https://portal.jc7transportes.com.br/api/transportadora`);
        const transportadoras = response.data;
        setTransportadoras(transportadoras);

        // Localizar a transportadora que corresponde ao CNPJ do usuário
        const transportadoraUsuario = transportadoras.find(
          (transp) => transp.CNPJ_TRANSP === usuario
        );

        if (transportadoraUsuario) {
          setSelectedTransportadora(transportadoraUsuario.COD_TRANSP); // Seleciona automaticamente o COD_TRANSP
        } else {
          console.warn("Nenhuma transportadora encontrada para o usuário logado.");
        }
      } catch (error) {
        console.error("Erro ao buscar transportadoras:", error);
      }
    };

    fetchTransportadoras();
  }, []);


  // Função para aplicar a máscara
  const aplicarMascaraContainer = (valor) => {
    // Remove todos os caracteres que não são letras ou números
    valor = valor.replace(/[^A-Za-z0-9]/g, "");

    // Aplica a máscara no formato ABCD-000.000-0
    if (valor.length <= 4) {
      return valor.toUpperCase();
    }
    if (valor.length <= 7) {
      return valor.slice(0, 4) + '-' + valor.slice(4, 7);
    }
    if (valor.length <= 10) {
      return valor.slice(0, 4) + '-' + valor.slice(4, 7) + '.' + valor.slice(7, 10);
    }
    return valor.slice(0, 4) + '-' + valor.slice(4, 7) + '.' + valor.slice(7, 10) + '-' + valor.slice(10, 11);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedTransportadora) {
      alert("Por favor, selecione uma transportadora.");
      return;
    }

    if (!tipoContainer) {
      alert("Por favor, selecione o tipo de Contêiner.");
      return;
    }

    if (!codMotorista) {
      alert("Por favor, informe o CPF e busque o motorista antes de enviar.");
      return;
    }

    if (!data || !horario) {
      alert("Por favor, selecione uma data e horário.");
      return;
    }

    // Combina a data e o horário no formato "YYYY-MM-DD HH:MM:SS"
    const dataAgenda = `${data} ${horario}:00`; // Exemplo: "2024-12-10 08:45:00"

    const payload = {
      tipoFluxo: tipofluxo,
      numeroContainer,
      codMotorista,
      codTransp: selectedTransportadora,
      tipoContainer,
      dataAgenda,
    };

    try {
      const response = await Axios.post("https://portal.jc7transportes.com.br/api/carregamento/agendamento", payload);

      if (response.status === 201) {
        const { ID_CARREGAMENTO } = response.data; // Captura o ID gerado pela API
        alert("Checklist enviado com sucesso!");

      // Atualiza a página após o envio bem-sucedido
      window.location.reload();
      } else {
        throw new Error("Erro ao enviar os dados.");
      }
    } catch (error) {
      console.error("Erro:", error);
      alert("Ocorreu um erro ao enviar os dados.");
    }
};


  const handleContainerChange = (e) => {
    setTipoContainer(e.target.value);
    console.log(`Selecionado Contêiner de ${e.target.value} pés`);
  };

  const handleDateChange = (event) => {
    const selectedDate = event.target.value; // Obtém a data no formato "YYYY-MM-DD"

    // Divide a data para criar um objeto Date sem considerar fuso horário
    const [year, month, day] = selectedDate.split("-");
    const dateObject = new Date(year, month - 1, day); // Converte para um objeto Date
    const selectedDay = dateObject.getDay(); // Obtém o dia da semana (0 = Domingo, 6 = Sábado)

    if (selectedDay === 0 || selectedDay === 6) {
      // Verifica se é sábado ou domingo
      showAlert("Agendamento não funciona aos Sábados e Domingos.", "error");
      setData(""); // Reseta a data selecionada
      return; // Sai da função para impedir atualizações
    }

    setData(selectedDate); // Atualiza a data se for válida
  };

  const handleHorarioClick = (time) => {
    if (!data) {
      showAlert("Por favor, selecione uma data primeiro.", "warning");
      return;
    }
    setHorario(time); // Atualiza o horário selecionado
  };

  const handleOpenDialog = () => {
    setOpenA(true); // Atualiza o estado para abrir o Dialog
  };

  return (
    <>
      <Navbar veiculos />
      <Header />
      <Brackground />
      <Container>
        <div className={style.content}>
          <div className={style.nav}>
            <div className={style.navbar} onClick={() => navigate("/agendamento/dashboardagendamento")}>
              Dashboard
            </div>
            <div className={style.active}>
              Agendamento
            </div>
          </div>
          <div className={style.checklist}>
            <h2>Agendamento de Contêiner Vazio</h2>

            <div className={style.radioGroup}>
              <label className={style.input}>
                <input
                  type="radio"
                  onChange={(e) => setTipoFluxo(e.target.value)}
                  value="ENTRADA"
                  name="tipofluxo"
                  checked={tipofluxo === "ENTRADA"}
                />
                ENTRADA
              </label>
              <label className={style.input}>
                <input
                  type="radio"
                  onChange={(e) => setTipoFluxo(e.target.value)}
                  value="SAÍDA"
                  name="tipofluxo"
                  checked={tipofluxo === "SAÍDA"}
                />
                SAÍDA
              </label>
            </div>

            <form onSubmit={handleSubmit}>
              <div>
                <label>
                  Número do Contêiner:
                  <input
                    type="text"
                    placeholder="Ex: ABCD-000.000-0"
                    value={numeroContainer}
                    onChange={(e) => setNumeroContainer(aplicarMascaraContainer(e.target.value))}
                    required
                  />
                </label>
              </div>
              <div>
                <label>
                  CPF do Motorista:
                  <input
                    type="number" // Alterado para text
                    placeholder="Digite o CPF (apenas números)"
                    value={cpfMotorista}
                    onChange={(e) => setCpfMotorista(e.target.value)}
                    onBlur={getMotorista} // Mantido, mas pode-se optar por um botão de busca
                    required
                  />
                </label>

              </div>
              {nomeMotorista && (
                <div>
                  <p>Motorista: <strong>{nomeMotorista}</strong></p>
                </div>
              )}

              {/* Modal de Cadastro de Motorista */}
              {showModal && (
                <div className={modalStyle.overlay}> {/* Camada de fundo escuro */}
                  <div className={modalStyle.modal}>
                    <div className={modalStyle.content}>
                      <h3>Motorista não encontrado</h3>
                      <p>Por favor, insira o nome completo do motorista para cadastrá-lo:</p>
                      <input
                        type="text"
                        value={nomeMotoristaModal}
                        onChange={(e) => setNomeMotoristaModal(e.target.value)}
                        placeholder="Nome Completo"
                        required
                      />
                      <button type="button" onClick={addMotorista}>Cadastrar Motorista</button>
                      <button type="button" onClick={() => setShowModal(false)}>Fechar</button>
                    </div>
                  </div>
                </div>
              )}

              {false && (
                <select
                  value={selectedTransportadora || ""} // Mostra o COD_TRANSP selecionado
                  onChange={(e) => setSelectedTransportadora(e.target.value)} // Atualiza o estado com o COD_TRANSP selecionado manualmente
                  required
                  style={{ display: "none" }} // Garante que o select esteja invisível
                >
                  <option disabled value="">
                    Escolha uma opção
                  </option>
                  {transportadoras.map((val) => (
                    <option value={val.COD_TRANSP} key={val.COD_TRANSP}>
                      {val.NOME_TRANSP} ({val.CNPJ_TRANSP})
                    </option>
                  ))}
                </select>
              )}

              <div className={style.containerType}>
                <label>Tipo de Contêiner</label>
                <div className={style.containerOptions}>
                  <label className={style.option}>
                    <input
                      type="radio"
                      name="tipoContainer"
                      value="40"
                      onChange={handleContainerChange}
                    />
                    <div className={style.iconWrapper}>
                      <img
                        src={QuarentaPes}
                        alt="Contêiner de 40 pés"
                        className={style.icon}
                      />
                      <p>40 Pés</p>
                    </div>
                  </label>
                  <label className={style.option}>
                    <input
                      type="radio"
                      name="tipoContainer"
                      value="20"
                      onChange={handleContainerChange}
                    />
                    <div className={style.iconWrapper}>
                      <img
                        src={VintePes}
                        alt="Contêiner de 20 pés"
                        className={style.icon}
                      />
                      <p>20 Pés</p>
                    </div>
                  </label>
                </div>

              </div>
              <div className={style.schedule}>
                <h3>Data e Hora de Agendamento</h3>
                <p>Escolha uma data e o sistema exibirá os horários disponíveis.</p>
                <div className={style.scheduleContainer}>
                  {/* Coluna da direita: Horários */}
                  <div className={style.timeSlotss}>
                    <h4> Selecione um horário</h4>
                    <input
                      type="date"
                      value={data}
                      onChange={handleDateChange}
                      required
                      min={new Date().toISOString().split("T")[0]} // Opcional: Define a data mínima como hoje
                    />

                    <div className={style.timeSlots}>
                      <div className={style.slots}>
                        {[
                          "08:36", "08:45", "08:54",
                          "09:03", "09:12", "09:21", "09:30", "09:39", "09:48", "09:57",
                          "10:06", "10:15", "10:24", "10:33", "10:42", "10:51",
                          "11:00", "11:09", "11:18", "11:27", "11:36", "11:45", "11:54",
                          "13:00", "13:09", "13:18", "13:27", "13:36", "13:45", "13:54",
                          "14:03", "14:12", "14:21", "14:30", "14:39", "14:48", "14:57",
                          "15:06", "15:15", "15:24", "15:33", "15:42", "15:51",
                          "16:00", "16:09", "16:18", "16:27", "16:36", "16:45", "16:54",
                        ].slice(activePage * 20, (activePage + 1) * 20).map((time, index) => (
                          <button
                            type="button"
                            key={index}
                            className={horario === time ? style.active : ""}
                            onClick={() => handleHorarioClick(time)}
                            disabled={!data} // Desabilita o botão se nenhuma data estiver selecionada
                          >
                            {time}
                          </button>
                        ))}
                      </div>

                      <div className={style.moreButtonContainer}>
                        <button
                          type="button"
                          onClick={() =>
                            setActivePage((prevPage) =>
                              prevPage < Math.ceil(60 / 20) - 1 ? prevPage + 1 : 0
                            )
                          }
                        >
                          Mais horários...
                        </button>
                      </div>
                    </div>
                  </div>

                </div>
                <div className={style.selection}>
                  {data && horario && (
                    <p>
                      <strong>Agendamento:</strong> {data} - {horario}
                    </p>
                  )}
                </div>
              </div>
              <div>
                <button type="submit">Enviar</button>
              </div>
            </form>
          </div>
        </div>
      </Container>
    </>
  );
};

export default function IntegrationNotistack() {
  return (
    <SnackbarProvider
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      maxSnack={3}
      autoHideDuration={2500}>
      <AgendamentoPesagem />
    </SnackbarProvider >
  );
}

